import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { GenericResponse } from 'src/app/api-interfaces';
import { IdentityService } from 'src/app/identity/identity.service';
import { TimerService } from '../timer/timer.service';

@Component({
  selector: 'app-resend-otp',
  templateUrl: './resend-otp.component.html',
  styleUrls: ['./resend-otp.component.sass']
})
export class ResendOtpComponent implements OnInit {
  @Input() disabled: boolean;
  @Input() errorTip: string;
  @Input() validateForm: UntypedFormGroup;
  @Input() numberSendOtp?: string;
  @Output() isSpinning = new EventEmitter<boolean>();
  interval: any;
  otpCodeVisible: boolean = false;
  formatterPieChart = (percent: number): string => `${this.timerService.timer}`;

  constructor(
    private identityService: IdentityService,
    public timerService: TimerService,
  ) { }

  ngOnInit(): void {
    this.timerService.isTimerSendOTPSetted();
  }

  get percentagePieChart () {
    return 100-Math.floor(100/60 * this.timerService.timer);
  }

  sendOtp(number?: string) {
    this.isSpinning.emit(true);
    this.timerService.setTimerOTP();
    this.identityService.requestOtp(number).subscribe((response: GenericResponse) => {
      if (response["esito"] == "OK") {
        this.isSpinning.emit(false);
      }
    },
      () => {
        this.isSpinning.emit(false);
      }
    );
  }

}
